import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface OnboardingState {
  currentStep: number;
  userRole: string | null;
  userData: Record<string, any>;
}

const initialState: OnboardingState = {
  currentStep: 0,
  userRole: null,
  userData: {},
};

const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    setCurrentStep(state, action: PayloadAction<number>) {
      state.currentStep = action.payload;
    },
    setUserRole(state, action: PayloadAction<string>) {
      state.userRole = action.payload;
    },
    updateUserData(state, action: PayloadAction<Record<string, any>>) {
      state.userData = { ...state.userData, ...action.payload };
    },
    resetOnboarding(state) {
      state.currentStep = 0;
      state.userRole = null;
      state.userData = {};
    },
  },
});

export const { setCurrentStep, setUserRole, updateUserData, resetOnboarding } = onboardingSlice.actions;

export default onboardingSlice.reducer;